/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { AxiosError, AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TBudgetAchievementlistGetReq,
  TBusyoBudgetAchievementlistGetReq,
  TBusyoBudgetAchievementlistPutReq,
  TBudgetAchievementListGetRes,
  TNinusiUriageListGetRes,
  TBusyoBudgetAchievementlistGetRes,
  TGekkanSyukeiPutReq,
  TSogoYusoKaigiPrintGetReq,
} from "./TSogoYusoKaigi"

/**
 * 業績会議に対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class sogoYusoKaigiService extends ConnectApi {
  /**
   * 予算実績リスト取得
   *
   * @param {TBudgetAchievementlistGetReq} params
   * @param {(param: TApiResponse<TBudgetAchievementListGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TBudgetAchievementListGetRes[]>) => any} reject
   * @memberof MenuService
   */
  getBudgetAchievementList = async (params: TBudgetAchievementlistGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TBudgetAchievementListGetRes[]>> =
        await this.getInner(`/budget/sogoyusokaigi/yosanzisseki`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 月間集計
   *
   * @param {TBudgetAchievementlistGetReq} params
   * @param {(param: TApiResponse<TBudgetAchievementListGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TBudgetAchievementListGetRes[]>) => any} reject
   * @memberof MenuService
   */
  postCreateGekkanSyukei = async (params: TBudgetAchievementlistGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TBudgetAchievementListGetRes[]>> =
        await this.postInner(
          `/budget/sogoyusokaigi/actions/createuriage`,
          params
        )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * 月間集計タイトル更新
   *
   * @param {TBudgetAchievementlistGetReq} params
   * @param {(param: TApiResponse<TBudgetAchievementListGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TBudgetAchievementListGetRes[]>) => any} reject
   * @memberof MenuService
   */
  putSyukeiTitle = async (params: TGekkanSyukeiPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TBudgetAchievementListGetRes[]>> =
        await this.putInner(`/budget/sogoyusokaigi/actions/updatetitle`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * 粗利益一覧取得
   *
   * @param {TBudgetAchievementlistGetReq} params
   * @param {(param: TApiResponse<TBudgetAchievementListGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TBudgetAchievementListGetRes[]>) => any} reject
   * @memberof MenuService
   */
  getGrossProfitList = async (params: TBudgetAchievementlistGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TBudgetAchievementListGetRes[]>> =
        await this.getInner(`/budget/sogoyusokaigi/ararieki`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 荷主売上一覧取得
   *
   * @param {TBudgetAchievementlistGetReq} params
   * @param {(param: TApiResponse<TBudgetAchievementListGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TBudgetAchievementListGetRes[]>) => any} reject
   * @memberof MenuService
   */
  getNinusiUriageList = async (params: TBudgetAchievementlistGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TNinusiUriageListGetRes[]>> =
        await this.getInner(`/budget/sogoyusokaigi/ninusiuriage`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 部所予算実績一覧取得
   *
   * @param {TBusyoBudgetAchievementlistGetReq} params
   * @param {(param: TApiResponse<TBusyoBudgetAchievementlistGetRes>) => any} resolve
   * @param {(param: TApiResponse<TBusyoBudgetAchievementlistGetRes>) => any} reject
   * @memberof MenuService
   */
  getBusyoBudgetAchievementList = async (
    params: TBusyoBudgetAchievementlistGetReq
  ) => {
    try {
      const res: AxiosResponse<
        TApiResponse<TBusyoBudgetAchievementlistGetRes>
      > = await this.getInner(`/budget/sogoyusokaigi/busyoyosanzisseki`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 月報（部署） 更新
   *
   * @param {TBusyoBudgetAchievementlistPutReq} data
   * @param {(param: TApiResponse<TSyaryoSyozokuListGetRes[]>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TSyaryoSyozokuListGetRes[]>>) => any} reject
   * @memberof SyaryoService
   */
  putBusyo = async (data: TBusyoBudgetAchievementlistPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `budget/sogoyusokaigi/actions/updatetext`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 予算実績帳票印刷
   *
   * @param {TSogoYusoKaigiPrintGetReq} params
   * @memberof zyomuinUnkoGeppoService
   */
  printYosanZissekiReport = async (
    params: TSogoYusoKaigiPrintGetReq,
    resolve?: (param: TApiResponse<Blob>) => any,
    reject?: (param: AxiosError<TApiResponse<Blob>>) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<Blob> = await this.postInner(
        `/report/CreateReport/G100302`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 粗利益一覧帳票印刷
   *
   * @param {TSogoYusoKaigiPrintGetReq} params
   * @memberof zyomuinUnkoGeppoService
   */
  printArariekiReport = async (
    params: TSogoYusoKaigiPrintGetReq,
    resolve?: (param: TApiResponse<Blob>) => any,
    reject?: (param: AxiosError<TApiResponse<Blob>>) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<Blob> = await this.postInner(
        `/report/CreateReport/G100303`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * 荷主売上一覧帳票印刷
   *
   * @param {TSogoYusoKaigiPrintGetReq} params
   * @memberof zyomuinUnkoGeppoService
   */
  printNinusiUriageReport = async (
    params: TSogoYusoKaigiPrintGetReq,
    resolve?: (param: TApiResponse<Blob>) => any,
    reject?: (param: AxiosError<TApiResponse<Blob>>) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<Blob> = await this.postInner(
        `/report/CreateReport/G100304`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * 部所予算実績帳票印刷
   *
   * @param {TSogoYusoKaigiPrintGetReq} params
   * @memberof zyomuinUnkoGeppoService
   */
  printBusyoYosanZissekiReport = async (
    params: TSogoYusoKaigiPrintGetReq,
    resolve?: (param: TApiResponse<Blob>) => any,
    reject?: (param: AxiosError<TApiResponse<Blob>>) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<Blob> = await this.postInner(
        `/report/CreateReport/G100305`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
